import * as R from "ramda";
import { createHandlers } from "redux-mvc";
import { NAMESPACE } from "./constants";

import moment from "moment";

const iniState = {
  loading: true,
  sessions: []
};

// TODO: MOVE THIS INTO A SELECTOR FILE
const sortByNameAsc = (a, b) => {
  const oneName = a.name.toUpperCase();
  const otherName = b.name.toUpperCase();
  if (oneName < otherName) {
    return -1;
  } else if (otherName < oneName) {
    return 1;
  } else {
    return 0;
  }
};

const sortByNameDesc = (a, b) => {
  const oneName = a.name.toUpperCase();
  const otherName = b.name.toUpperCase();
  if (oneName > otherName) {
    return -1;
  } else if (otherName > oneName) {
    return 1;
  } else {
    return 0;
  }
};

const sortByNewestToOldest = (a, b) => {
  const { meta: metaA = {} } = a || {};
  const { meta: metaB = {} } = b || {};

  const { starts_at: starts_atA = null } = metaA;
  const { starts_at: starts_atB = null } = metaB;

  const oneDate = moment(starts_atA);
  const otherDate = moment(starts_atB);
  if (oneDate < otherDate) {
    return -1;
  } else if (otherDate < oneDate) {
    return 1;
  } else {
    return 0;
  }
};

const sortByLastUpdated = (a, b) => {
  const oneDate = moment(a.last_updated_at);
  const otherDate = moment(b.last_updated_at);
  if (oneDate > otherDate) {
    return -1;
  } else if (otherDate > oneDate) {
    return 1;
  } else {
    return 0;
  }
};

const model = createHandlers({
  iniState,
  reducers: {
    init: R.identity,
    setFilter: R.identity,
    setSorting: (state, { payload: sortBy }) => {
      const sortingFunctions = {
        name_az: sortByNameAsc,
        name_za: sortByNameDesc,
        last_updated: sortByLastUpdated,
        newest_to_oldest: sortByNewestToOldest
      };
      const sortFunction = sortingFunctions[sortBy];
      if (sortFunction) {
        const sortedSessions = R.isEmpty(state.sessions)
          ? []
          : state.sessions.sort(sortFunction);
        return {
          ...state,
          sessions: [...sortedSessions]
        };
      }
      return state;
    }
  },
  namespace: NAMESPACE
});

const { actions, getters } = model;

export { actions, getters };

export default model;
